import { render, staticRenderFns } from "./TicketsData.vue?vue&type=template&id=4bb5764b&scoped=true&"
import script from "./TicketsData.vue?vue&type=script&lang=js&"
export * from "./TicketsData.vue?vue&type=script&lang=js&"
import style0 from "./TicketsData.vue?vue&type=style&index=0&id=4bb5764b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb5764b",
  null
  
)

export default component.exports